import { getEffectiveTaxRates } from 'src/action-window/business-logic/service/get-effective-tax-rates';
import { store } from 'src/common/redux/configure-store';
import { ItemListActions } from 'src/common/redux/reducers/item-list-reducer';

export const setTaxRates = async (): Promise<void> => {
  const rates = await getEffectiveTaxRates();
  store.dispatch(ItemListActions.setEffectiveTaxRates(rates));
};
